"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ActionItem = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.promise.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hooks = require("../../../../hooks");
var _Spinner = require("../../../UIElements/Spinner/Spinner");
var _Icon = require("../../../UIElements/Icons/PetSure/Icon");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ActionItem = _ref => {
  let {
    id = 'submitButton',
    buttonStyle = 'primary',
    buttonLabel = 'Submit',
    actionButtonIcon = null,
    onClick = () => {},
    disabled = false,
    showSpinner = false,
    hidden = false
  } = _ref;
  const [spinnerActive, setSpinnerActive] = (0, _react.useState)(false);
  const buttonRef = (0, _react.useRef)(null);
  const handleOnClick = async () => {
    if (showSpinner) {
      setSpinnerActive(true);
      await Promise.resolve(onClick());
      setSpinnerActive(false);
    } else {
      onClick();
    }
  };
  (0, _hooks.useTracking)({
    elementRef: buttonRef,
    trackingProps: {
      label: buttonLabel,
      field: {
        inputType: 'button',
        id
      }
    }
  });
  return !hidden && /*#__PURE__*/_react.default.createElement("button", {
    ref: buttonRef,
    id: id,
    className: "button ".concat(spinnerActive ? 'spinnerShowing' : '', " ").concat(buttonStyle),
    type: "button",
    onClick: handleOnClick,
    disabled: disabled
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "labelText"
  }, actionButtonIcon && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: actionButtonIcon
  }), buttonLabel), spinnerActive && /*#__PURE__*/_react.default.createElement(_Spinner.Spinner, null));
};
exports.ActionItem = ActionItem;
ActionItem.propTypes = {
  id: _propTypes.default.string,
  buttonStyle: _propTypes.default.string,
  buttonLabel: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  actionButtonIcon: _propTypes.default.string,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  showSpinner: _propTypes.default.bool,
  hidden: _propTypes.default.bool
};
var _default = exports.default = ActionItem;